import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import Product from 'app/features/landing/productComparison/components/Product/Product';
import { products } from 'app/features/products/selectors';

const UI = ({ products }) =>
  products.map(({ sku }) => <Product key={sku} sku={sku} />);

UI.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({ sku: PropTypes.string.isRequired }),
  ).isRequired,
};

UI.displayName = 'Products';

const Products = connect({ products })(UI);

export { UI };

export default Products;
